/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionDataset } from './InformationExtractionDataset';
import {
  InformationExtractionDatasetFromJSON,
  InformationExtractionDatasetFromJSONTyped,
  InformationExtractionDatasetToJSON,
} from './InformationExtractionDataset';

/**
 *
 * @export
 * @interface PaginatedInformationExtractionDatasetList
 */
export interface PaginatedInformationExtractionDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedInformationExtractionDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedInformationExtractionDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedInformationExtractionDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<InformationExtractionDataset>}
   * @memberof PaginatedInformationExtractionDatasetList
   */
  results: Array<InformationExtractionDataset>;
}

/**
 * Check if a given object implements the PaginatedInformationExtractionDatasetList interface.
 */
export function instanceOfPaginatedInformationExtractionDatasetList(
  value: object,
): value is PaginatedInformationExtractionDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedInformationExtractionDatasetListFromJSON(
  json: any,
): PaginatedInformationExtractionDatasetList {
  return PaginatedInformationExtractionDatasetListFromJSONTyped(json, false);
}

export function PaginatedInformationExtractionDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedInformationExtractionDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(InformationExtractionDatasetFromJSON),
  };
}

export function PaginatedInformationExtractionDatasetListToJSON(
  value?: PaginatedInformationExtractionDatasetList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(InformationExtractionDatasetToJSON),
  };
}
